import merge from 'lodash.merge'
import { OrderItemStates } from '../consts.js'

export default function generalProcessor(order, offlineEnabled, clientSocket, catalog) {

  function getRandomElementsFromObject(obj, count) {
    let result = []
    for (let i = 0; i < count; i++) {
      let keys = Object.keys(obj)
      let randomKey = keys[Math.floor(Math.random() * keys.length)]
      if (randomKey) {
        result.push({ ...obj[randomKey] })
        delete obj[randomKey]
      } else {
        break
      }
    }
    return result
  }

  function getOrderUpsales(maxSuggestions = 3, isVisible = true) {
    let suggestions = {}

    for (let orderItem of Object.values(order.assembledOrderItems)) {
      let count = (orderItem.count != null && orderItem.state <= OrderItemStates.STORNO) ? orderItem.count : 0
      if (count > 0) {
        let itemUpsales = catalog.getItemUpsales(
          orderItem.uuid,
          order.order.locationUUID,
          isVisible
        )
        suggestions = merge(suggestions, itemUpsales)
      }
    }
    let randomItems = getRandomElementsFromObject(suggestions, maxSuggestions)
    return Object.values(randomItems)
  }

  function setSandbox(sandbox) {
    order.addUpdate({ sandbox: (sandbox ? 1 : 0) })
  }

  function setLocation(locationUUID) {
    if (order.order.locationUUID === locationUUID) { return }
    if (order.order.tableUUID) {
      order.addUpdate({ tableUUID: null })
    }
    order.addUpdate({ locationUUID })
  }

  function setTakeAway(takeAway) {
    order.addUpdate({ takeAway })
  }

  function setLanguage(languageCode) {
    order.addUpdate({ languageCode })
  }

  function setCurrency(currency) {
    order.addUpdate({ currency })
  }

  function setDeliveryInfo(deliveryInfo = null, deliveryType = null, deliveryCost = null) {
    if (deliveryInfo != null) {
      order.addUpdate({ deliveryInfo })
    } else {
      order.addUpdate({ deliveryInfo: null })
    }
    if (deliveryType != null) { order.addUpdate({ deliveryType }) }
    if (deliveryCost != null) { order.addUpdate({ deliveryCost }) }
  }

  function setInvoiceInfo(invoiceInfo) {
    order.addUpdate({
      invoiceInfo
    })
  }

  function setInvoiceNeeded(invoiceNeeded) {
    order.addUpdate({
      invoiceNeeded
    })
  }

  function setServiceFeePercent(percent) {
    order.addUpdate({ serviceFee: { percent } })
  }

  function setNotes(notes) {
    order.addUpdate({
      notes
    })
  }

  function setRequestedReadyTime(requestedReadyTime) {
    order.addUpdate({
      requestedReadyTime
    })
  }

  function setPaymentType(paymentType) {
    order.addUpdate({
      paymentType
    })
  }

  function setTable(tableUUID) {
    order.addUpdate({
      tableUUID: tableUUID ? tableUUID : ''
    })
  }

  function setGroup(groupUUID) {
    order.addUpdate({
      groupUUID: groupUUID ? groupUUID : ''
    })
  }

  function setOrderIdentifier(orderIdentifier) {
    order.addUpdate({
      orderIdentifier
    })
  }

  function setTipAmount(tipAmount) {
    order.addUpdate({
      tipAmount
    })
  }
  
  function setOrderType(orderType, personnelUUID, consumerUUID) {
    order.addUpdate({ orderType: +orderType, personnelUUID: personnelUUID || null, consumerUUID: consumerUUID || null })
  }

  return {
    setSandbox,
    getOrderUpsales,
    setLocation,
    setTakeAway,
    setLanguage,
    setCurrency,
    setDeliveryInfo,
    setInvoiceInfo,
    setInvoiceNeeded,
    setNotes,
    setRequestedReadyTime,
    setPaymentType,
    setTable,
    setGroup,
    setOrderIdentifier,
    setTipAmount,
    setServiceFeePercent,
    setOrderType
  }
}
